const CHATKIT_OPEN_STORAGE_KEY = 'chatkit-open';

let toggleHandler = null;
let closeHandler = null;

export function open() {
  const container = document.getElementById('chatkit-widget-container');
  if (!container) return;

  const chatWindow = container.querySelector('#chatkit-window');
  const toggleButton = container.querySelector('#chatkit-toggle');
  if (!chatWindow || !toggleButton) return;

  chatWindow.style.display = 'flex';
  toggleButton.style.display = 'none';
  localStorage.setItem(CHATKIT_OPEN_STORAGE_KEY, 'true');
  document.dispatchEvent(new CustomEvent('chatkit.toggle.open'));
}

export function close() {
  const container = document.getElementById('chatkit-widget-container');
  if (!container) return;

  const chatWindow = container.querySelector('#chatkit-window');
  const toggleButton = container.querySelector('#chatkit-toggle');
  if (!chatWindow || !toggleButton) return;

  chatWindow.style.display = 'none';
  toggleButton.style.display = 'block';
  localStorage.removeItem(CHATKIT_OPEN_STORAGE_KEY);
  document.dispatchEvent(new CustomEvent('chatkit.toggle.close'));
}

function toggle() {
  if (localStorage.getItem(CHATKIT_OPEN_STORAGE_KEY) === 'true') {
    close();
  } else {
    open();
  }
}

export function setup() {
  const container = document.getElementById('chatkit-widget-container');
  if (!container) return;

  const toggleButton = container.querySelector('#chatkit-toggle');
  const closeButton = container.querySelector('#chatkit-close');

  toggleHandler = () => toggle();
  closeHandler = () => close();

  if (toggleButton) toggleButton.addEventListener('click', toggleHandler);
  if (closeButton) closeButton.addEventListener('click', closeHandler);

  const params = new URLSearchParams(window.location.search);
  const autoOpenChat = params.get(CHATKIT_OPEN_STORAGE_KEY) === 'true'
    || localStorage.getItem(CHATKIT_OPEN_STORAGE_KEY) === 'true';

  if (autoOpenChat) open();
}

export function cleanup() {
  const container = document.getElementById('chatkit-widget-container');

  if (container) {
    const toggleButton = container.querySelector('#chatkit-toggle');
    const closeButton = container.querySelector('#chatkit-close');
    if (toggleButton && toggleHandler) toggleButton.removeEventListener('click', toggleHandler);
    if (closeButton && closeHandler) closeButton.removeEventListener('click', closeHandler);
  }

  toggleHandler = null;
  closeHandler = null;
}
